module.exports = __webpack_public_path__ + "static/media/Arizona_Coyotes.51725724.svg";